import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useHttp, useNotification } from 'src/hooks';
import { useAccount } from 'wagmi';

const YoutubeCallback: React.FC = () => {
  const navigate = useNavigate();
  const { sendRequest, error: errorSubscribing } = useHttp();
  const notify = useNotification();

  const urlParams = new URLSearchParams(window.location.search);
  const code = urlParams.get('code');
  const state = urlParams.get('state');
  const { address } = useAccount();
  const [showPopup, setShowPopup] = useState(false);

  const fetchYoutubeUser = () => {
    sendRequest(
      {
        url: `youtube/callback?code=${code}&state=${state}`,
        method: 'GET',
      },
      (data: any) => {
        if (data) {
          setShowPopup(true); // Show the popup
        }

        // navigate('/multiversx/detail');
      },
    );
  };
  const handleSubscribe = () => {
    if (address) {
      sendRequest(
        {
          url: `youtube/subscribe/${address}`,
          method: 'POST',
        },
        (response: any) => {
          notify('Successfully subscribed to the channel!', 'success');
          setShowPopup(false);
          navigate('/multiversx/detail');
        },
      );
    }
  };

  useEffect(() => {
    fetchYoutubeUser();
  }, [address]);

  useEffect(() => {
    if (errorSubscribing) {
      notify(`${errorSubscribing}` , 'error');
    }
  }, [errorSubscribing]);

  return (
    <div>
      {showPopup && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-75">
          <div className="bg-white rounded-lg p-6 w-80 text-center">
            <h2 className="text-lg font-bold text-black mb-4">Subscribe to the Channel</h2>
            <button
              onClick={handleSubscribe}
              className="bg-black text-white px-4 py-2 rounded-lg hover:bg-gray-800"
            >
              Subscribe
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default YoutubeCallback;
